module.exports = function getResource(label, vars = []) {
    const resources = {
        back: 'Back',
        retake: 'Retake',
        saveAndContinue: 'Save and Continue',
        signInToSave: 'Sign In to Save',
        seeMatchingProducts: 'See Matching Products'
    };

    return resources[label];
};
